import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import moment from 'moment';


Snappy.Component.WembleyStadiumEnquiryForm = class WembleyStadiumEnquiryForm extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-ws-enquiry-form';
    }

    constructor(element) {
        super(element)
    }

    setVars() {
        this.errorMessage = document.getElementsByClassName('fa-input-field__error-message');
        this.preferredDateInput = document.getElementById('preferred-date');
        this.checkedCheckboxes = [];
        this.checkboxContainers = document.querySelectorAll('.checkbox__input');
        this.preferredDateField = document.getElementsByName('preferred_date');
        this.numberOfGuestField = document.getElementsByName('guest_numbers');
        this.titleField = document.getElementsByName('title');
        this.firstNameField = document.getElementsByName('first_name');
        this.surnameField = document.getElementsByName('surname');
        this.emailField = document.getElementsByName('email');
        this.companyNameField = document.getElementsByName('company_name');
        this.contactNumberField = document.getElementsByName('contact_number');
        this.otherRequirementsField = document.getElementsByName('other_requirements');
        this.jobTitleField = document.getElementsByName('job_title');
        this.eventTimeField = document.getElementsByName('event_time');
        this.hearAboutUsField = document.getElementsByName('hear_about_us');
        this.formTextInputs = document.querySelectorAll('.fa-enquiry-form__form input[type=text]');
        this.submitBtn = document.getElementById('ws-enquiry-form-submit');

    }

    addEventListeners() {
        this.submitBtn.addEventListener('click', this.validateForm.bind(this));
        this.preferredDateInput.addEventListener('keydown', this.addForwardSlash.bind(this))
        for (var i = 0; i < this.formTextInputs.length; i++) {
            this.formTextInputs[i].addEventListener('keyup', this.removeErrors.bind(this));
        }
    }

    removeErrors(event) {
        if (event.target.classList.contains('error')) {
            event.target.classList.remove('error');
            event.target.nextSibling.nextElementSibling.style.display = 'none';
        }
    }

    addForwardSlash(event) {
        const inputLength = event.target.value.length;

        if (event.keyCode === 8) {
            return false;
        }

        if (inputLength === 2 || inputLength === 5) {
            event.target.value += '/';
        }
    }

    validateForm(event) {
        event.preventDefault();
        let isValidDate;
        let isEmailValid;
        let allInputsComplete = false;
        const requiredFields = {
            preferredDate: 'preferred_date',
            guestNumbers: 'guest_numbers',
            title: 'title',
            firstName: 'first_name',
            surname: 'surname',
            email: 'email',
            companyName: 'company_name',
            contactNumber: 'contact_number'
        }

        // add errors to all required fields
        Object.keys(requiredFields).forEach(function (key) {
            let fieldName = document.getElementsByName(`${requiredFields[key]}`)

            for (var i = 0; i < fieldName.length; i++) {
                if (fieldName[i].value === '') {
                    fieldName[i].classList.add('error');
                    fieldName[i].nextSibling.nextElementSibling.innerHTML = `Please enter a ${fieldName[i].previousSibling.previousElementSibling.innerHTML.toLowerCase()}`;
                    fieldName[i].nextSibling.nextElementSibling.style.display = 'block';
                } else if (fieldName[i].value) {
                    fieldName[i].classList.remove('error');
                    fieldName[i].nextSibling.nextElementSibling.innerHTML = '';
                    fieldName[i].nextSibling.nextElementSibling.style.display = 'none';
                }
            }
        });

        
       

        // check if recaptcha is valid
        this.isRecaptchaValid();

        // check if event type is checked
        this.isEventTypeChecked(this.checkboxContainers);

        // scroll up to div if error exists
        if ($('.error').length) {
            $('html, body').animate({
                scrollTop: $('.error:visible:first').offset().top - 130
            }, 1000);
        }
        
        // check if date is valid
        if (!(this.preferredDateField[0].value)) {
            return false;
        }

        isValidDate = moment(this.preferredDateField[0].value, 'DD/MM/YYYY', true).isValid();
        
        if (isValidDate) {
            this.preferredDateField[0].classList.remove('error');
            this.preferredDateField[0].nextSibling.nextElementSibling.innerHTML = ''
            this.preferredDateField[0].nextSibling.nextElementSibling.style.display = 'none';
        } else {
            this.preferredDateField[0].classList.add('error');
            this.preferredDateField[0].nextSibling.nextElementSibling.innerHTML = 'Please enter a valid date'
            this.preferredDateField[0].nextSibling.nextElementSibling.style.display = 'block';
        }

        // check if email is valid
        if (!(this.emailField[0].value)) {
            return false;
        }

        isEmailValid = this.validateEmail(this.emailField[0].value);

        if (isEmailValid) {
            this.emailField[0].classList.remove('error');
            this.emailField[0].nextSibling.nextElementSibling.innerHTML = ''
            this.emailField[0].nextSibling.nextElementSibling.style.display = 'none';
        } else {
            this.emailField[0].classList.add('error');
            this.emailField[0].nextSibling.nextElementSibling.innerHTML = 'Please enter a valid email address'
            this.emailField[0].nextSibling.nextElementSibling.style.display = 'block';
        }

       
        

        // final check on inputs
        if ((!(this.numberOfGuestField[0].value)) || (!(this.titleField[1].value)) ||
            (!(this.firstNameField[0].value)) ||
            (!(this.surnameField[0].value)) ||
            (!(this.surnameField[0].value)) ||
            (!(this.companyNameField[0].value)) ||
            (!(this.contactNumberField[0].value)) ||
            (!(this.checkedCheckboxes.length)) ||
            (!(isValidDate)) ||
            ($("#g-recaptcha-response").val() === '')) {
            return false
        }

        

        this.postFormData();
    }

    isRecaptchaValid() {
        const recaptcha = $("#g-recaptcha-response").val();
        const recaptchaError = document.querySelectorAll('.recaptcha-error')[0];

        if (recaptcha === "") {
            recaptchaError.innerHTML = 'Please check the recaptcha';
            recaptchaError.style.display = 'block';
        } else {
            recaptchaError.style.display = 'none';
        }
    }

    postFormData() {
        let eventTime;
        let hearAboutUs;
        const endpoint = document.getElementsByClassName('fa-enquiry-form__form')[0].getAttribute('action');
        for (var i = 0; i < this.eventTimeField.length; i++) {
            eventTime = this.eventTimeField[i];
        }
        for (var i = 0; i < this.hearAboutUsField.length; i++) {
            hearAboutUs = this.hearAboutUsField[i];
        }

        //construct form object
        const formPayload = {
            'selectedEventTypes' : this.checkedCheckboxes,
            'preferredDate' : this.preferredDateField[0].value,
            'guestNumber' : this.numberOfGuestField[0].value,
            'title' : this.titleField[1].value,
            'firstName' : this.firstNameField[0].value,
            'surname' : this.surnameField[0].value,
            'email' : this.emailField[0].value,
            'eventTime' : eventTime.value,
            'otherRequirements' : this.otherRequirementsField[0].value,
            'jobTitle' : this.jobTitleField[0].value,
            'companyName' : this.companyNameField[0].value,
            'contactNumber' : this.contactNumberField[0].value,
            'hearAboutUs' : hearAboutUs.value
        };

        //show loading GIF
        $('.loading-message-wrapper').removeClass('hide').addClass('show');

        $.ajax({
            url: endpoint,
            type: "POST",
            data: JSON.stringify(formPayload),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            error: function (response) {
                document.querySelectorAll('.submission__error')[0].style.display = 'block';
                $('.fa-enquiry-form__form').slideUp('slow');
            },
            success: function (response) {
                //hide loading GIF animation
                $('.loading-message-wrapper').removeClass('show').addClass('hide');
                document.querySelectorAll('.submission__success')[0].style.display = 'block';
                $('.fa-enquiry-form__form').slideUp('slow');
            }
        });
    }

    validateEmail(email) {
        const expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return expr.test(email);
    };

    isEventTypeChecked(checkboxInputs) {
        const checkBoxError = document.querySelector('.event-type-error');
        let atleastOneChecked = false;

        for (var i = 0; i < checkboxInputs.length; i++) {
            if (!(checkboxInputs[i].checked)) {
                checkBoxError.innerHTML = 'Please select at least one event type';
                checkBoxError.style.display = 'block';
                checkBoxError.classList.add('error');
            } else {
                atleastOneChecked = true;

                this.checkedCheckboxes.indexOf(checkboxInputs[i].name) === -1 ? this.checkedCheckboxes.push(checkboxInputs[i].name) : console.log('item already exists!!');
            }
        }

        if (atleastOneChecked) {
            checkBoxError.innerHTML = '';
            checkBoxError.style.display = 'none';
            checkBoxError.classList.remove('error'); 
        }
    };

    render() {
        this.setVars();
        this.addEventListeners();
    };
}



// WEBPACK FOOTER //
// ./components/ws-enquiry-form/scripts/enquiry-form.js